const amazonLogoUrl = 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/amazon-order-history/logo.png'

const content = {
    amazon_order_history_lang_content: {
        en: {
            data_type_description: 'Amazon Order History',
            summary_html: '',
            summary_no_video_html:`
                <p>Retro jobs are simple, quick and a bit of fun too. Read the steps below, and then you're ready to hit
                    record and scroll through your purchase history.</p>
                <div class="text-with-icon">
                <div class="icon">⚠️</div>
                <div class="text">
                    We’ll only pay MSR rewards for videos that fully match the steps below.
                </div>
                </div>`,
            steps: [
                {
                    step_type: 'numbered_step',
                    number: '1',
                    description_html: '<p>Open the <b>Amazon</b> shopping app and login before starting to screen record.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '2',
                    description_html: '<p>Tap the menu icon and tap <b>Your orders</b>.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '3',
                    description_html: `<p>Use the filter to select <b>Orders</b> and <b>2022</b> before
                        tapping <b>Apply</b>.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '4',
                    description_html: `<p>Scroll to the end of your selected history before you stop recording.</p>`
                }
            ],
        },
        es: {
            data_type_description: 'Amazon historial de pedidos',
            summary_html: '',
            summary_no_video_html:`
                <p>Los trabajos retro son simples, rápidos y también un poco divertidos. Lea los pasos a continuación, y luego estará listo para golpear
                registre y desplácese por su historial de compras.</p>
                <div class="text-with-icon">
                <div class="icon">⚠️</div>
                <div class="text">
                Solo pagaremos recompensas de MSR por videos que coincidan completamente con los pasos a continuación.
                </div>
                </div>`,
            steps: [
                {
                    step_type: 'numbered_step',
                    number: '1',
                    description_html: '<p>Abra la aplicación de compras de <b>Amazon</b> e inicie sesión antes de comenzar a grabar la pantalla.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '2',
                    description_html: '<p>Toca el ícono de menú y toca <b>Tus pedidos</b>.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '3',
                    description_html: `<p>Utilice el filtro para seleccionar <b>Pedidos</b> y <b>2022</b> antes
                    tocando <b>Aplicar</b>.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '4',
                    description_html: `<p>Desplácese hasta el final de su historial seleccionado antes de detener la grabación.</p>`
                }
            ],
        },
    },
    amazon_search_history_lang_content: {
        en: {
            data_type_description: 'Amazon Search History',
            summary_html: "<p>Retro jobs are simple, quick and a bit of fun too. Watch the video and read the steps below, and then you're ready to hit record and scroll through your purchase history.</p>",
            summary_no_video_html: "<p>Retro jobs are simple, quick and a bit of fun too. Read the steps below, and then you're ready to hit record and scroll through your purchase history.</p>",
            steps: [
              {
                step_type: 'numbered_step',
                number: '1',
                description_html: '<p>Open the <b>Amazon</b> shopping app and login. Start screen recording.</p>'
              },
              {
                step_type: 'numbered_step',
                number: '2',
                description_html: '<p>Tap on <b>Search Amazon</b> at top of screen.</p>'
              },
              {
                step_type: 'numbered_step',
                number: '3',
                description_html: `<p>Stop screen recording.</p>`
              },
            ],
        }
    },
    wholefoods_order_history_lang_content: {
        en: {
            data_type_description: 'Wholefoods Order History',
            summary_html: "<p>Retro jobs are simple, quick and a bit of fun too. Watch the video and read the steps below, and then you're ready to hit record and do your Retro thing.</p>",
            summary_no_video_html: "<p>Retro jobs are simple, quick and a bit of fun too. Read the steps below, and then you're ready to hit record and do your Retro thing.</p>",
            steps: [
              {
                step_type: 'numbered_step',
                number: '1',
                description_html: '<p>Do some things.</p>'
              },
              {
                step_type: 'numbered_step',
                number: '2',
                description_html: '<p>Do more things.</p>'
              }
            ],
        }
    },
    alexa_history_lang_content: {
        en: {
            data_type_description: 'Alexa History',
            summary_html: '',
            summary_no_video_html: `
            <p>Retro jobs are simple, quick and a bit of fun too. Read the steps below, and then you're ready to hit
                record and scroll through your Alexa voice history.</p>
            <div class="text-with-icon">
                <div class="icon">⚠️</div>
                <div class="text">
                We’ll only pay MSR rewards for videos that fully match the steps below.
                </div>
            </div>`,
            steps: [
                {
                    step_type: 'numbered_step',
                    number: '1',
                    description_html: '<p>Open the <b>Amazon Alexa</b> app and log in.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '2',
                    description_html: '<p>Start the screen recording.</p>'
                },
                {
                    step_type: 'numbered_step',
                    number: '3',
                    description_html: `<p>Click the <b>More</b> tab (bottom-right).</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '4',
                    description_html: `<p>Click on <b>Activity</b> and then <b>Voice History</b>.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '5',
                    description_html: `<p>Change the "Displaying" item to <b>Last 30 days, All Devices</b>.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '6',
                    description_html: `<p>Scroll through the list until you reach the end - it says <b>End of list</b>.</p>`
                },
                {
                    step_type: 'numbered_step',
                    number: '4',
                    description_html: `<p>Stop the screen recording and upload.</p>`
                },
            ],
        },
    },
    twitch_channels: {
        en: {
            summary_html: '',
        summary_no_video_html: `
            <p>This Retro is all about your Twitch viewing - the channels you subscribe to and the types of gameplay you watch. Its easy to complete and will just take 2 mins.</p>
            <p>
                Tap on the following option that applies to you.
            </p>`,
        multiple_steps: [
            {
                title: 'I have the Twitch app installed',
                steps: [
                    {
                        step_type: 'numbered_step',
                        number: '1',
                        description_html: '<p>Open the <b>Twitch app</b> and log in.</p>'
                    },
                    {
                        step_type: 'numbered_step',
                        number: '2',
                        description_html: '<p>Start the screen recording.</p>'
                    },
                    {
                        step_type: 'numbered_step',
                        number: '3',
                        description_html: `In the Following Menu - scroll from the top of the screen to the bottom.</p>`
                    },
                    {
                        step_type: 'numbered_step',
                        number: '4',
                        description_html: `Now click on your <b>Profile</b> (top left hand corner).</p>`
                    },
                    {
                        step_type: 'numbered_step',
                        number: '5',
                        description_html: `<p>Then click <b>Subscriptions</b> - scroll from top to bottom.</p>`
                    },
                    {
                        step_type: 'numbered_step',
                        number: '6',
                        description_html: `<p>Now in the <b>Following</b> channel - go to last video channel.</p>`
                    },
                    {
                        step_type: 'numbered_step',
                        number: '7',
                        description_html: `<p>Click on <b>Videos</b> section.</p>`
                    },
                    {
                        step_type: 'numbered_step',
                        number: '8',
                        description_html: `<p>Now click on each of the last viewed videos and scroll through them one by one.</p>`
                    },
                    {
                        step_type: 'numbered_step',
                        number: '9',
                        description_html: `<p>Then click <b>View Purchase History</b>.</p>`
                    },
                    {
                        step_type: 'numbered_step',
                        number: '10',
                        description_html: `<p>Stop the screen recording and upload.</p>`
                    },
                ]
            },
            {
                title: 'I do NOT have the Twitch app installed',
                steps: [
                    {
                        step_type: 'numbered_step',
                        number: '1',
                        description_html: '<p>Click this link: <a href="https://www.twitch.tv/" target="_blank">Twitch</a>. Start the screen recording.</p>'
                    },
                    {
                        step_type: 'numbered_step',
                        number: '2',
                        description_html: '<p>Sign in to your Twitch account.</p>'
                    },
                    {
                        step_type: 'numbered_step',
                        number: '3',
                        description_html: `Scroll from top to the bottom of the screen.</p>`
                    },
                    {
                        step_type: 'numbered_step',
                        number: '4',
                        description_html: `Now click on your <b>Profile</b> (top left hand corner).</p>`
                    },
                    {
                        step_type: 'numbered_step',
                        number: '5',
                        description_html: `<p>Then click <b>Subscriptions</b> - scroll from top to bottom.</p>`
                    },
                    {
                        step_type: 'numbered_step',
                        number: '6',
                        description_html: `<p>Now in the Following channel - go to last video channel.</p>`
                    },
                    {
                        step_type: 'numbered_step',
                        number: '7',
                        description_html: `<p>Click on <b>Videos</b> section.</p>`
                    },
                    {
                        step_type: 'numbered_step',
                        number: '8',
                        description_html: `<p>Now click on each of the last viewed videos and scroll through them one by one.</p>`
                    },
                    {
                        step_type: 'numbered_step',
                        number: '9',
                        description_html: `<p>Then click <b>View Purchase History</b>.</p>`
                    },
                    {
                        step_type: 'numbered_step',
                        number: '10',
                        description_html: `<p>Stop the screen recording and upload.</p>`
                    },
                ],
            }
        ],
        }
    },
}

export const amazonDataTypes = {
    'amazon_order_history': {
            data_type: 'amazon_order_history',
            logo: amazonLogoUrl,
            capture_type: 'video',
            android: {
                use_in_app_screen_recorder: true,
                ...content.amazon_order_history_lang_content,
            },
            ios: {
                use_in_app_screen_recorder: false,
                ...content.amazon_order_history_lang_content,
            }
        },
    'amazon_search_history': {
        data_type: 'amazon_search_history',
        capture_type: 'video',
        logo: amazonLogoUrl,
        android: {
            use_in_app_screen_recorder: true,
            ...content.amazon_search_history_lang_content,
        },
        ios: {
            use_in_app_screen_recorder: false,
            ...content.amazon_search_history_lang_content,
        }
    },
    'wholefoods_order_history': {
        data_type: 'wholefoods_order_history',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/wholefoods-order-history/wholefoods.png',
        capture_type: 'video',
        android: {
            use_in_app_screen_recorder: true,
            ...content.wholefoods_order_history_lang_content,
        },
        ios: {
            use_in_app_screen_recorder: false,
            ...content.wholefoods_order_history_lang_content,
        }    
    },
    'alexa_history': {
        data_type: 'alexa_history',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/alexa-history/logo.png',
        capture_type: 'video',
        android: {
            use_in_app_screen_recorder: true,
            ...content.alexa_history_lang_content,
        },
        ios: {
            use_in_app_screen_recorder: false,
            ...content.alexa_history_lang_content,
        }
        
    },
    twitch_channels: {
        data_type: 'twitch_channels',
        data_type_description: 'Twitch Channels',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/twitch/twitch_logo4.png',
        capture_type: 'video',
        ios: {
            use_in_app_screen_recorder: false,
            ...content.twitch_channels
        },
        android: {
            use_in_app_screen_recorder: true,
            ...content.twitch_channels
        },
        
    },
}

